/*
 * @Description:
 * @Author: luckymiaow
 * @Date: 2022-04-29 17:00:08
 * @LastEditors: luckymiaow
 */

import { computed, inject, unref } from 'vue';
import { kebabCase } from 'lodash-es';
import useConfigProvider from '../../config-provider/src/useConfigProvider';
import type { FormConfig } from '../types';

// 注入key
export const formProvideKey = Symbol('formConfig');

// 显示插槽
export const readOnlySlot = 'readOnly';

export const defaultInject = {
  bordered: true,
  readOnly: false,
  readOnlyStyle: () => ({}),
  readOnlyClassName: undefined,
  placeholder: null,
} as FormConfig as any;

// 通用表单注入,全局配置注入，默认返回所有attr
export default <T extends FormConfig>({ props, componentName, attrs }: any) => {
  const { injectConfig } = useConfigProvider();

  const config = (inject(formProvideKey, {}) ?? {}) as any;

  const provideConfig = injectConfig<T>(componentName) ?? {};

  function getInjectFormAttrs(_attrs: Record<string, any>) {
    const result: any = {};
    Object.keys(defaultInject).forEach(key => {
      if (kebabCase(key) in _attrs) result[key] = _attrs[kebabCase(key)];
      else if (key in config) result[key] = config[key];
    });
    return result;
  }

  function getInject() {
    const result: any = {};
    Object.keys(unref(provideConfig)).forEach((key: any) => {
      if (!(key in props) || props[key] === undefined) result[key] = (unref(provideConfig) as any)[key];
    });
    return result;
  }

  const getBindValue = computed(() => {
    const bind: T = {
      ...defaultInject,
      ...props,
      ...attrs,
      ...getInject(),
      ...getInjectFormAttrs(attrs),
    };
    if (bind.readOnly) {
      bind.bordered = false;
      bind.placeholder = null;
    } else {
      bind.bordered = { ...attrs, ...props }?.bordered;
      bind.placeholder = { ...attrs, ...props }?.placeholder;
    }
    return bind;
  });

  return { getBindValue };
};
